export default __webpack_public_path__ + "static/media/subscription-link.31f8a31e.png";